export const seanceTypeOptions = [
  { value: 'SANTÉ', label: 'SANTÉ' },
  { value: 'ESTHETIQUE', label: 'ESTHÉTIQUE' },
  { value: 'SPORT', label: 'SPORT' }
];

export const typesSeance = seanceTypeOptions.map(({ value }) => value);

const stripDiacritics = (value = '') => value.normalize('NFD').replace(/[̀-ͯ]/g, '');

export const normalizeSeanceType = (value) => {
  const normalized = stripDiacritics(String(value || '').trim()).toUpperCase();

  if (normalized === 'SANTE') return 'SANTÉ';
  if (normalized === 'ESTHETIQUE') return 'ESTHETIQUE';
  if (normalized === 'SPORT') return 'SPORT';

  return String(value || '').trim();
};

export const getSeanceTypeLabel = (value) => {
  const normalized = normalizeSeanceType(value);
  const option = seanceTypeOptions.find(({ value: optionValue }) => optionValue === normalized);
  return option?.label || String(value || 'SÉANCE').trim() || 'SÉANCE';
};

export const groupesMusculaires = [
  'Pecs', 'Dos', 'Jambes', 'Epaules', 'Biceps', 'Triceps', 'Abdominaux', 'Fessiers', 'Mollets'
];

// exemples d'ateliers (peuvent être personnalisés par le prof via "paramètres muscu")
export const exemplesAteliers = [
  'Développé couché', 'Pompes', 'Tractions', 'Rowing', 'Squat', 'Fente', 'Soulevé de terre', 'Leg curl',
  'Elévations latérales', 'Curl barre', 'Dips', 'Plank'
];